var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{attrs:{"value":_vm.value,"clearable":"","placeholder":"请选择"},on:{"input":_vm.setValue}},[_c('el-option',{attrs:{"value":0,"label":"请选择"}}),_vm._l((_vm.category_names),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.menu,"value":item.id}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }